/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateCallExecution200Response,
  CreateCallExecutionRequest,
  FindAllCallExecutions200Response,
  FindCallExecutionById200Response,
  GetPayorConfigForFacility200Response,
} from '../models/index';
import {
    CreateCallExecution200ResponseFromJSON,
    CreateCallExecution200ResponseToJSON,
    CreateCallExecutionRequestFromJSON,
    CreateCallExecutionRequestToJSON,
    FindAllCallExecutions200ResponseFromJSON,
    FindAllCallExecutions200ResponseToJSON,
    FindCallExecutionById200ResponseFromJSON,
    FindCallExecutionById200ResponseToJSON,
    GetPayorConfigForFacility200ResponseFromJSON,
    GetPayorConfigForFacility200ResponseToJSON,
} from '../models/index';

export interface CreateCallExecutionOperationRequest {
    leadId: string;
    createCallExecutionRequest: CreateCallExecutionRequest;
}

export interface FindAllCallExecutionsRequest {
    leadId: string;
}

export interface FindCallExecutionByIdRequest {
    leadId: string;
    callExecutionId: string;
}

export interface GetPayorConfigForFacilityRequest {
    facilityId: string;
}

export interface RetryCallAnalysisRequest {
    leadId: string;
    callExecutionId: string;
}

export interface RetryCallExecutionRequest {
    leadId: string;
    callExecutionId: string;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Create a new call execution
     */
    async createCallExecutionRaw(requestParameters: CreateCallExecutionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCallExecution200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling createCallExecution.');
        }

        if (requestParameters.createCallExecutionRequest === null || requestParameters.createCallExecutionRequest === undefined) {
            throw new runtime.RequiredError('createCallExecutionRequest','Required parameter requestParameters.createCallExecutionRequest was null or undefined when calling createCallExecution.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/{lead_id}/call-executions`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCallExecutionRequestToJSON(requestParameters.createCallExecutionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCallExecution200ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new call execution
     */
    async createCallExecution(requestParameters: CreateCallExecutionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCallExecution200Response> {
        const response = await this.createCallExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all call executions for a lead
     */
    async findAllCallExecutionsRaw(requestParameters: FindAllCallExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllCallExecutions200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findAllCallExecutions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/{lead_id}/call-executions`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllCallExecutions200ResponseFromJSON(jsonValue));
    }

    /**
     * List all call executions for a lead
     */
    async findAllCallExecutions(requestParameters: FindAllCallExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllCallExecutions200Response> {
        const response = await this.findAllCallExecutionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a call execution record
     */
    async findCallExecutionByIdRaw(requestParameters: FindCallExecutionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindCallExecutionById200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findCallExecutionById.');
        }

        if (requestParameters.callExecutionId === null || requestParameters.callExecutionId === undefined) {
            throw new runtime.RequiredError('callExecutionId','Required parameter requestParameters.callExecutionId was null or undefined when calling findCallExecutionById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/{lead_id}/call-executions/{call_execution_id}`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"call_execution_id"}}`, encodeURIComponent(String(requestParameters.callExecutionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindCallExecutionById200ResponseFromJSON(jsonValue));
    }

    /**
     * Get a call execution record
     */
    async findCallExecutionById(requestParameters: FindCallExecutionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindCallExecutionById200Response> {
        const response = await this.findCallExecutionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get enabled payor configuration for a facility
     */
    async getPayorConfigForFacilityRaw(requestParameters: GetPayorConfigForFacilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPayorConfigForFacility200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling getPayorConfigForFacility.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payor-config/{facility_id}`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPayorConfigForFacility200ResponseFromJSON(jsonValue));
    }

    /**
     * Get enabled payor configuration for a facility
     */
    async getPayorConfigForFacility(requestParameters: GetPayorConfigForFacilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPayorConfigForFacility200Response> {
        const response = await this.getPayorConfigForFacilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Re-analyze a call execution transcript which failed to process
     */
    async retryCallAnalysisRaw(requestParameters: RetryCallAnalysisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling retryCallAnalysis.');
        }

        if (requestParameters.callExecutionId === null || requestParameters.callExecutionId === undefined) {
            throw new runtime.RequiredError('callExecutionId','Required parameter requestParameters.callExecutionId was null or undefined when calling retryCallAnalysis.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/{lead_id}/call-executions/{call_execution_id}/retry-analysis`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"call_execution_id"}}`, encodeURIComponent(String(requestParameters.callExecutionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Re-analyze a call execution transcript which failed to process
     */
    async retryCallAnalysis(requestParameters: RetryCallAnalysisRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.retryCallAnalysisRaw(requestParameters, initOverrides);
    }

    /**
     * Retry an existing call execution
     */
    async retryCallExecutionRaw(requestParameters: RetryCallExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCallExecution200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling retryCallExecution.');
        }

        if (requestParameters.callExecutionId === null || requestParameters.callExecutionId === undefined) {
            throw new runtime.RequiredError('callExecutionId','Required parameter requestParameters.callExecutionId was null or undefined when calling retryCallExecution.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/{lead_id}/call-executions/{call_execution_id}/retry`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"call_execution_id"}}`, encodeURIComponent(String(requestParameters.callExecutionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCallExecution200ResponseFromJSON(jsonValue));
    }

    /**
     * Retry an existing call execution
     */
    async retryCallExecution(requestParameters: RetryCallExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCallExecution200Response> {
        const response = await this.retryCallExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
